/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    HEAR_CREATE_FAILURE,
    HEAR_CREATE_REQUEST,
    HEAR_CREATE_SUCCESS,
    HEAR_FANPAGE_ATTACH_FAILURE,
    HEAR_FANPAGE_ATTACH_REQUEST,
    HEAR_FANPAGE_ATTACH_SUCCESS,

} from '../types';

/**
 * @param {*} state
 * @param {*} action
 */
const HearCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case HEAR_CREATE_FAILURE:
        case HEAR_CREATE_REQUEST:
        case HEAR_CREATE_SUCCESS:
        case HEAR_FANPAGE_ATTACH_FAILURE:
        case HEAR_FANPAGE_ATTACH_REQUEST:
        case HEAR_FANPAGE_ATTACH_SUCCESS:
            return {
                ...state,
                data: action.payload
            };
        default:
            return state;
    }
};

export {
    HearCreateReducer
}